import BannerList from './BannerList';
import BannerCreate from './BannerCreate';
import BannerEdit from './BannerEdit';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const bannerResource = {
  list: BannerList,
  create: BannerCreate,
  edit: BannerEdit,
  icon: () => <Icon><Box component="img" src='icons/banners.svg' /></Icon>,
};

export default bannerResource;